// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from './base-entity';
import { EquipmentAttachment } from './equipment-attachment';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class EquipmentAttachmentType extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  equipmentAttachmentTypeId: number;
  attTypeName: string;
  equipmentAttachments: EquipmentAttachment[];
}

